export default function UiButton( {buttonClass,caption, onClick} ){
    return <button
        className={buttonClass}
        onClick={onClick}
    >
        {caption}
    </button>
}